import { ChargeWaiverRegistrationEntity } from "domain/entity/ChargeWaiverRegistration/ChargeWaiverRegistrationEntity";
import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { axiosGetData, axiosPostData } from "../axios/AxiosBasicImpl";
import referenceAxiosInstance from "../axios/referenceAxiosInstance";
import { ChargeWaiverRegistrationRepository } from "./ChargeWaiverRegistrationRepo";

export const ChargeWaiverRegistrationRepoImpl = (): ChargeWaiverRegistrationRepository => {
    const url = '/v1/chargeWaiverRegistration';

    const getEntities = async (): Promise<ChargeWaiverRegistrationEntity[]> => {
        return axiosGetData(referenceAxiosInstance, url, []).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const onSave = async (entity: ChargeWaiverRegistrationEntity): Promise<ResponseEntity> => {
        return await axiosPostData(referenceAxiosInstance, `${url}`, entity);
    }


    return {
        onSave: onSave,
        getEntities: getEntities
    }
}